import APIConfig from "apiconfig";

export default APIConfig;
